import { getCookieDomain } from '@/utils/cookie'

export const useApolloToken = () => {
  const tokenCookie = useCookie('apollo-token', {
    path: '/',
    expires: new Date(Date.now() + 432000),
    maxAge: 60 * 60 * 24 * 5,
    domain: getCookieDomain()
  })

  const expiresCookie = useCookie('apollo-expires', {
    path: '/',
    expires: new Date(Date.now() + 432000),
    maxAge: 60 * 60 * 24 * 5,
    domain: getCookieDomain()
  })

  const convertIdCookie = useCookie('ota-conv-context', {
    path: '/',
    maxAge: 60 * 60 * 24 * 5,
    domain: getCookieDomain()
  })

  const userIdCookie = useCookie('ota-uid', {
    path: '/',
    maxAge: 60 * 60 * 24 * 5,
    domain: getCookieDomain()
  })

  const jtwCookie = useCookie('jwt_hp', {
    path: '/',
    expires: new Date(Date.now() + 432000),
    maxAge: 60 * 60 * 24 * 5,
    domain: getCookieDomain()
  })

  const tokenNoDomain = useCookie('apollo-token')
  const expiresNoDomain = useCookie('apollo-expires')
  const convertIdNoDomain = useCookie('ota-conv-context')
  const userIdNoDomain = useCookie('ota-uid')
  const jwtNoDomain = useCookie('jwt_hp')

  const token = computed(() => tokenCookie?.value || '')
  const expires = computed(() => expiresCookie?.value || '')
  const convertId = computed(() => convertIdCookie?.value || '')
  const userId = computed(() => userIdCookie?.value || '')

  const setToken = (value: string | null) => {
    tokenCookie.value = value
  }

  const setExpires = (value: string | null) => {
    expiresCookie.value = value
  }

  const setConvertId = (value: string | null) => {
    convertIdCookie.value = value
  }

  const setUserId = (value: string | null) => {
    userIdCookie.value = value
  }

  const clearAllCookies = () => {
    // Clear cookies with domain
    tokenCookie.value = null
    expiresCookie.value = null
    convertIdCookie.value = null
    userIdCookie.value = null
    jtwCookie.value = null

    // Also clear cookies without domain (for migration/cleanup)
    tokenNoDomain.value = null
    expiresNoDomain.value = null
    convertIdNoDomain.value = null
    userIdNoDomain.value = null
    jwtNoDomain.value = null
  }

  return {
    tokenCookie,
    token,
    setToken,
    expiresCookie,
    expires,
    setExpires,
    convertIdCookie,
    convertId,
    setConvertId,
    userIdCookie,
    userId,
    setUserId,
    clearAllCookies
  }
}
